var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCloseBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 26.667,
    viewBox: "897.667 60.667 26.667 26.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911 60.667A13.321 13.321 0 0 0 897.667 74c0 7.373 5.96 13.333 13.333 13.333s13.333-5.96 13.333-13.333-5.96-13.333-13.333-13.333Zm6.667 18.12-1.88 1.88L911 75.88l-4.787 4.787-1.88-1.88L909.12 74l-4.787-4.787 1.88-1.88L911 72.12l4.787-4.787 1.88 1.88L912.88 74l4.787 4.787Z",
    fill: "#5b87b4",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 40"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBlue);
export default __webpack_public_path__ + "static/media/icon-close-blue.3c37f1aa02617cf2728f5c0d65d8c02e.svg";
export { ForwardRef as ReactComponent };